const TITLES = {
  titleDataForTutor: 'Ingresa los datos del beneficiario menor de edad',
  titleQueryOptions: 'Selecciona una opción',
  maintenance: '¡El sitio está actualmente fuera de servicio por mantenimiento!',
  landing: '¡Aviso importante!',
  ready: '¡Listo!',
};

export default { TITLES };
